import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

const TopHero = ({ title, subtitle, home }) => {
  return (
    <>
      {home === "home" ? (
        <Wrapper home>
        <div className="home-center">
          <div className="text">
            
            <h1>{title}</h1>
            <p>{subtitle}</p>
          </div>

          <div className="links">
            <Link to="#" className="btn btn-main">
              take the tour
            </Link>
            <Link to="#" className="btn btn-bordered">
              get started
            </Link>
          </div>
        </div>
        </Wrapper>
      ) : (
        <Wrapper>
        <div className="page-center">
          <div className="text">
            <h1>{title}</h1>
            <p>{subtitle}</p>
          </div>
        </div>
        </Wrapper>
      )}

    </>
  )
}

const Wrapper = styled.section`
  min-height: ${ (props) => props.home
  ? 'calc(100vh - (50px + 94px))' 
  : '60vh' };
  @media screen and (min-width: 768px) {
    min-height: ${ (props) => props.home
    ? 'calc(100vh - (101px + 94px))' 
    : '60vh' };
  }
  
  display: flex ;
  align-items: center;
  justify-content: center;

  .page-center { width: 90vw; margin: 0 auto;
    h1 { font-size: 32px; line-height: 50px; text-align: center;
      @media screen and (min-width: 1025px) { font-size: 64px; line-height: 120%; }
    }
    p { text-align: center; font-size: 16px; line-height: 190%;
        @media screen and (min-width: 1025px) { font-size: 25px; margin-top: 40px; }
    }
  }

  .home-center { width: 90vw; margin: 0 auto;
    @media screen and (min-width: 321px) { width: 70vw; }
    @media screen and (min-width: 667px) { width: 74vw; }
    @media screen and (min-width: 768px) { width: 90vw; }
    @media screen and (min-width: 1025px) { width: 81.5vw; }
    
    h1 { width: 80vw; font-size: 32px; line-height: 50px;
      @media screen and (min-width: 321px) { width: 75vw; }
      @media screen and (min-width: 1025px) {
        margin-top: 66px;
        margin-bottom: 44px;
        width: 65vw;
        font-size: 56px;
        line-height: 120%;
      }
    }
    p { font-size: 20px; }
  }

 
  .links {
    margin-top: 48px;
    display: flex;
    flex-direction: column;
    width: 100%;
    a { margin-bottom: 20px; }
    /* Iphone SE horizontally*/
    @media screen and (min-width: 568px) and (orientation: landscape) {
      flex-direction: row;
      width: 100%;
      a:first-child { margin-right: 20px; }
      a { margin-bottom: 0; }
    }
    @media screen and (min-width: 768px) {
      flex-direction: row;
      justify-content: space-between;
      .btn {
        margin-right: 60px!important;
        font-size: 16px;
      }
      .btn-bordered { border:.5px solid var(--clr-primary-1);}
    }
    @media screen and (min-width: 1024px) {
      justify-content: flex-start;
      a {
        margin-right: 40px;
      }
    }
  }

  .btn {
    text-align: center;
  }
`
export default TopHero
